import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { signOut } from "@/account/lib/auth-client";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@nosible/shared/components/ui/card";

export function Logout() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const performLogout = async () => {
      try {
        await signOut({
          fetchOptions: {
            onSuccess: () => {
              if (window.location.hostname !== "app.nosible.com") {
                navigate("/login");
                return;
              }
              const logout = new URL("https://nosible.world/api/auth/world/logout");
              logout.searchParams.set("return_to", `${window.location.origin}/login`);
              window.location.assign(logout.toString());
            },
            onError: () => {
              setError("Failed to log out. Please try again.");
            },
          },
        });
      } catch {
        setError("Failed to log out. Please try again.");
      }
    };

    performLogout();
  }, [navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-obsidian">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle>Logout Failed</CardTitle>
            <CardDescription>{error}</CardDescription>
          </CardHeader>
          <CardContent>
            <button
              onClick={() => navigate("/login")}
              className="text-neon-green hover:underline"
            >
              Go to login
            </button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-obsidian">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Logging out...</CardTitle>
          <CardDescription>Please wait while we sign you out.</CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}
